import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import packageSmsApis from '../../../../services/packageSmsApis';
import dayjs from 'dayjs';
import { IGetSummaryRequestSMSResponse, ISummaryRequestSMSParams } from '../../interfaces/apis';

const DEFAULT_PARAMS: ISummaryRequestSMSParams = {
  shopId: undefined,
  status: undefined,
  startDate: dayjs().subtract(7, 'day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetSummaryRequestSMS = () => {
  const [data, setData] = useState<IGetSummaryRequestSMSResponse | null>(null);
  const [params, setParams] = useState(DEFAULT_PARAMS);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IGetSummaryRequestSMSResponse }> = await packageSmsApis.getSummaryRequestSMSPurchase({
        status: params.status ? params.status : undefined,
        shopId: params.shopId ? params.shopId : undefined,
        startDate: dayjs(params.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(params.endDate).format('MM-DD-YYYY'),
      });
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package dashboard:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return { data, loading, params, setParams };
};

export default useGetSummaryRequestSMS;
